const GroupedRenderer = ({
  question,
  value = {},
  onChange,
  isEditable
}) => {

  const schema =
    question.ui_schema || {};

  const fields =
    schema.fields || [];

  const handleChange = (
  key,
  fieldValue
) => {

  const updatedValues={
  ...value,
  [key]:fieldValue
};

// =====================================
// RADIO RESET LOGIC
// =====================================

fields.forEach((field)=>{

  // =====================================
  // AUTO CLEAR TEXT/TEXTAREA ON RADIO NO
  // =====================================

  if(
    field.type==="textarea" ||
    field.type==="text"
  ){

    const radioField=fields.find(
      f=>f.type==="radio"
    );

    if(
      radioField &&
      key===radioField.key &&
      Number(fieldValue)===0
    ){

      updatedValues[field.key]="";
    }
  }

});

  let systemValue = "";

  try {

    const formula =
  schema?.derived?.formula ||
  schema?.formula;

    if (formula) {

      let computed =
        formula;

      fields.forEach((field) => {

        computed =
  computed.replace(
    new RegExp(
      `\\b${field.key}\\b`,
      "g"
    ),
    Number(
        updatedValues?.[
          field.key
        ] || 0
      )
  );
      });

      const result =
        eval(computed);

      if (!isNaN(result)) {

        systemValue =
          Number(
            result.toFixed(2)
          );
      }

    }

  } catch {

    systemValue = "";
  }

  onChange(
    question.question_code,
    {
      ...updatedValues,
      system_value:
        systemValue
    }
  );
};

  // ===================================
  // DERIVED
  // ===================================

  let derivedValue = "";

  try {

    const formula =
  schema?.derived?.formula ||
  schema?.formula;

    if (formula) {

      let computed =
        formula;

      fields.forEach((field) => {

        computed =
  computed.replace(
    new RegExp(
      `\\b${field.key}\\b`,
      "g"
    ),
    Number(
      value?.[field.key] || 0
    )
  );
      });

      const result =
        eval(computed);

      if (!isNaN(result)) {

        derivedValue =
          Number(
            result.toFixed(2)
          );
      }
    }

  } catch {

    derivedValue = "";
  }

  return (

    <div className="grouped-renderer">

      <div className="grouped-grid">

       {fields.map((field) => {

  // ==========================
  // FIELD CONDITIONAL
  // ==========================

const conditionalTypes = [
  "text",
  "textarea",
  "number",
  "email",
  "date",
  "url"
];

const conditional=
  field.conditional;

// ==========================================
// AUTO CONDITIONAL FOR TEXTAREA
// ==========================================

if(
  conditionalTypes.includes(field.type) &&
  fields.some(f=>f.type==="radio") &&
  !field.conditional
){
  const radioField =
    fields.find(f => f.type==="radio");

  const radioValue =
    value?.[radioField.key];

  if(Number(radioValue)!==1){
    return null;
  }
}

// ==========================================
// CUSTOM CONDITIONAL
// ==========================================

if(conditional){

  const parentValue=
    value?.[
      conditional.field
    ];

  if(
    Number(parentValue)!==
    Number(conditional.value)
  ){

    return null;
  }
}

  // ==========================
// RADIO FIELD
// ==========================

if(field.type==="radio"){

  return(

    <div
      key={field.key}
      className="grouped-field"
    >

      <label>
        {field.label}
      </label>

      <div className="radio-group">

        {(field.options || []).map((option)=>(

          <label
            key={option.value}
            className="radio-label"
          >

            <input
              type="radio"
              name={field.key}
              value={option.value}
              checked={
                Number(value?.[field.key]) ===
                Number(option.value)
              }
              disabled={!isEditable}
              onChange={()=>
                handleChange(
                  field.key,
                  option.value
                )
              }
            />

            <span>
              {option.label}
            </span>

          </label>

        ))}

      </div>

    </div>

  );
}
  // ==========================
  // BOOLEAN FIELD
  // ==========================

  if (field.type === "boolean") {

    return (

      <div
        key={field.key}
        className="grouped-field"
      >

        <label className="checkbox-label">

          <input className="brsr-checkbox"
            type="checkbox"
            checked={
              Number(
                value?.[field.key]
              ) === 1
            }
            disabled={!isEditable}
            onChange={(e) =>
              handleChange(
                field.key,
                e.target.checked
                  ? 1
                  : 0
              )
            }
          />

          <span>
            {field.label}
          </span>

        </label>

      </div>

    );

  }

  // ==========================
  // NORMAL FIELD
  // ==========================

  return (

    <div
      key={field.key}
      className="grouped-field"
    >

      <label>
        {field.label}
      </label>

      {field.type === "textarea" ? (

  <textarea
    className="org-field-input"
    rows={field.rows || 4}
    placeholder={field.placeholder}
    value={
      value?.[field.key] ?? ""
    }
    disabled={!isEditable}
    onChange={(e) =>
      handleChange(
        field.key,
        e.target.value
      )
    }
  />

) : (

  <input
    type={
      field.type || "text"
    }
    min={field.min}
    className="org-field-input"
    placeholder={field.placeholder}
    value={
      value?.[field.key] ?? ""
    }
    disabled={!isEditable}
    onChange={(e) =>
      handleChange(
        field.key,
        e.target.value
      )
    }
  />

)}

    </div>

  );

})}

        {schema?.derived && (

          <div className="grouped-field">

            <label>
              {
                schema.derived.label
              }
            </label>

            <input
              type="text"
              className="org-field-input"
              value={derivedValue}
              disabled
            />

          </div>

        )}

      </div>

    </div>

  );
};

export default GroupedRenderer;
